import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../../../public/images/mt.svg'


const _hoisted_1 = { class: "row landing-header justify-between items-center q-mt-md" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "q-mr-sm"
}, null, -1)
const _hoisted_3 = { class: "mt-text" }
const _hoisted_4 = { class: "column justify-center items-center q-mt-xl q-pt-xl" }
const _hoisted_5 = { class: "dialog__title" }
const _hoisted_6 = { class: "row landing-header justify-between items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "q-mr-sm"
}, null, -1)
const _hoisted_8 = { class: "mt-text" }
const _hoisted_9 = { class: "column justify-center items-center q-pt-xl landing-dialog" }
const _hoisted_10 = { class: "dialog__wrapper" }
const _hoisted_11 = { class: "dialog__title" }
const _hoisted_12 = { class: "dialog__subTitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_page = _resolveComponent("q-page")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_page_container = _resolveComponent("q-page-container")!

  return (_openBlock(), _createBlock(_component_q_page_container, null, {
    default: _withCtx(() => [
      (_ctx.emailSent)
        ? (_openBlock(), _createBlock(_component_q_page, {
            key: 0,
            class: "main-container q-layout-container"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", {
                  class: "row items-center cursor-pointer masons-logo",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args)))
                }, [
                  _hoisted_2,
                  _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('dialogs.resetPassword.title')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t('dialogs.resetPassword.subTitle')), 1)
              ])
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_q_page, { key: 1 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: "row items-center cursor-pointer masons-logo",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args)))
                }, [
                  _hoisted_7,
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('dialogs.resetPassword.title')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_q_form, { onSubmit: _ctx.submit }, {
                    default: _withCtx(() => [
                      _createElementVNode("h2", _hoisted_11, _toDisplayString(_ctx.$t('dialogs.resetPassword.callToAction.title')), 1),
                      _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.$t('dialogs.resetPassword.callToAction.subTitle')), 1),
                      _createVNode(_component_q_input, {
                        outlined: "",
                        onFocus: _ctx.resetErrors,
                        "label-color": "white",
                        label: _ctx.$t('input.labels.email'),
                        modelValue: _ctx.email,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email) = $event)),
                        type: "email",
                        error: _ctx.passwordResetError,
                        "error-message": "Invalid email"
                      }, null, 8, ["onFocus", "label", "modelValue", "error"]),
                      _createVNode(_component_Button, {
                        centered: "",
                        class: "btn__submit",
                        label: _ctx.$t('btn.send'),
                        type: "submit",
                        loading: _ctx.loading
                      }, null, 8, ["label", "loading"]),
                      _createVNode(_component_router_link, {
                        to: "/",
                        style: {"font-size":"16px","margin-top":"20px","margin-bottom":"0px","display":"inline-block"},
                        class: "col link-text dialog__subTitle"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('dialogs.resetPassword.callToAction.remember')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onSubmit"])
                ])
              ])
            ]),
            _: 1
          }))
    ]),
    _: 1
  }))
}